
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuDeliveryPizzaHarajukuPizzaTakeoutImage } from "@src/constants/images";
import { meta as naprePageMeta } from "./napre.mdx";
import { meta as kevelosPageMeta } from "./kevelos.mdx";
export const meta = {
  path: "/media/harajuku/delivery_pizza",
  title: "【百名店限定！】原宿で本格派のピザがデリバリーできる名店３選",
  description: "原宿で本格派のピザのデリバリーができるお店を厳選してご紹介！今回は、食べログ百名店に選出されているお店に厳選してご紹介させていただきます。Uber Eatsが使える店や、人気のピザ、支払い方法など、デリバリーで購入する際に気になることをまとめました。",
  topImg: harajukuDeliveryPizzaHarajukuPizzaTakeoutImage,
  author: murakamiMasanori,
  tags: ["原宿", "有名店", "人気店", "まとめ記事", "メニュー詳細", "デリバリー", "イタリアン"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿で本格派のピザのデリバリーができるお店を厳選してご紹介！今回は、原宿・表参道・青山からもアクセスができる、食べログ百名店に選出されているお店に厳選してご紹介させていただきます。`}</p>
    <p>{`Uber Eats が使える店や、人気のピザ、支払い方法など、デリバリーで購入する際に気になることをまとめました。`}</p>
    <p>{`チェーン店ではなく、本格的なピザをデリバリーで楽しんでいただけると嬉しいです。`}</p>
    <hr></hr>
    <h2>{`ナプレ 南青山本店`}</h2>
    <InstaImage postId="B9BCBRqjP4M" mdxType="InstaImage" />
    <p>{`ナプレは日本に初めてナポリピザを持ち込んだお店として、都内に複数店舗展開しているピッツェリアです。ナポリ南青山本店は、食べログ百名店に選出されており、原宿・表参道・青山エリアにとどまらず、その人気は幅広い世代に受け入れられています。`}</p>
    <h3>{`ピザ職人が作る本物のピザ`}</h3>
    <p>{`ナプレでは、ナポリ・ピザ大会で入賞した`}<strong parentName="p">{`ピッツァイオーロ(ピザ職人のイタリアでの名称)`}</strong>{`が焼いてくれる、本物に近いナポリピザが食べられるお店です。`}</p>
    <h3>{`イタリアから仕入れた食材`}</h3>
    <p>{`素晴らしい職人がいても、材料によって味は大きく左右されます。 ナプレでは、イタリアから直送されるオーガニックの「小麦粉」「トマト缶」「新鮮な野菜」を使用してピザを作り上げています。本場の食材で作るピザは、イタリア人が「故郷を思い出す」と言うほど。そんな本場の食材を使った本場に近い味を、デリバリー(Uber Eats) で注文することができます。`}</p>
    <h3>{`マリナーラ(1,800 円)`}</h3>
    <InstaImage postId="B1LjNrmgccK" mdxType="InstaImage" />
    <p>{`トマト、ガーリックなどの少ない食材で作るピザがマリナーラ。シンプルな食材だからこそ、生地の食感、食材の味、ピザ職人の腕が試されるのがこのピザになります。`}</p>
    <h3>{`マルゲリータ(2,000 円)`}</h3>
    <InstaImage postId="B-YUwP5gAp6" mdxType="InstaImage" />
    <p>{`マリナーラをベースに、モッツァレラチーズをふんだんに使ったピザがマルゲリータ。身近なピザだからこそ、デリバリーでも頼みやすいメニューですよね。`}</p>
    <h3>{`プロシュット　エ　ルーコラ(2,700 円)`}</h3>
    <InstaImage postId="B9GovU9BwWZ" mdxType="InstaImage" />
    <p>{`生ハムとルッコラがふんだんに使われたピザ！塩気のある生ハムとシャキシャキとした食感が楽しめる外さない一品になっています。`}</p>
    <h3>{`支払い`}</h3>
    <p>{`Uber Eats での支払いになるので、
クレジットカードや電子マネーが使用できます！`}</p>
    <LinkWithThumbnail meta={naprePageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`ピッツァ ケベロス 明治神宮前店`}</h2>
    <InstaImage postId="B9BCBRqjP4M" mdxType="InstaImage" />
    <p>{`ピザケベロスはマリナーラが人気名お店として知られています。インスタグラムでケベロスを調べてみると、たくさんのマリナーラの写真を確認することができます。原宿でナプレとトップを争う人気店で、食べログの評価は 3.7 以上(2020 年 5 月時点)という人気っぷり。そんなピッツァ ケベロスのデリバリーについてご紹介します！`}</p>
    <h3>{`デリバリーは限定的`}</h3>
    <p>{`デリバリーは`}<strong parentName="p">{`2,500 円以上`}</strong>{`の注文の場合で注文できるのですが、2 枚以上頼むと 2,500 円以上を超えるので、一人暮らしの方でない限りは、デリバリーができることが多いのではないかと思います。`}</p>
    <h3>{`マリナーラ(1,300 円)`}</h3>
    <InstaImage postId="B-Zr1RslN5R" mdxType="InstaImage" />
    <p>{`「トマト、バジル、熟成ニンニク、オレガノ(ハーブのような葉っぱ)」の４種類しか使わないマリナーラ。
マリナーラが`}<strong parentName="p">{`ケベロス(KEVELOS)の 1 番人気`}</strong>{`のメニューになっており、デリバリーで注文ができます。
シンプルだけどお客様から選ばれ続けているピザです！`}</p>
    <h3>{`フィレマリナーラ(税込：1,500 円)`}</h3>
    <InstaImage postId="B0KdOrSBoHw" mdxType="InstaImage" />
    <InstaImage postId="BKajepyjZMu" mdxType="InstaImage" />
    <p>{`マリナーラにチェリートマトを加えたピザで、甘みと酸味のどちらも楽しめるピザ。
シンプルだからこそピッツァメニューの中で一番テクニックを要し、ケベロス(KEVELOS)の常連さんに人気のピザになってます！
デリバリーでマリナーラとフィレマリナーラを頼んで、食べ比べしてみるのもおもしろそうですよね。`}</p>
    <h3>{`マルゲリータ(税込：1,500 円)`}</h3>
    <InstaImage postId="B2UA6RAlSg-" mdxType="InstaImage" />
    <InstaImage postId="B8JBTWMHpmt" mdxType="InstaImage" />
    <p>{`とろとろのモッツァレラチーズ、トマト、バジルで作る王道のピザになります！
こちらも馴染みのあるシンプルなピザですが、食材が織りなす繊細はな味わいを楽しんでください！`}</p>
    <h3>{`支払い`}</h3>
    <p>{`クレジットカードが使用できます！普段現金を持たない人でも安心して決済ができるのは嬉しいですよね。`}</p>
    <LinkWithThumbnail meta={kevelosPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`ピッツェリア カンテラ`}</h2>
    <InstaImage postId="B8_Dr1PAynw" mdxType="InstaImage" />
    <p>{`ピッツェリア カンテラは立地の良さとお洒落なピザが食べられることで、女子会などでもよく使われるお店です。食べログの評価も 3.68(2020 年 5 月時点)で、`}<strong parentName="p">{`三年連続食べログのピザ百名店`}</strong>{`に選出されている人気っぷり。
テイクアウトやデリバリーのメニューも人気なので、今回はデリバリーメニューについてご紹介させていただきます。`}</p>
    <h3>{`オーガニック食材を使ったピザが楽しめる！`}</h3>
    <p>{`国産小麦「春よこい」を石臼で挽いた全粒粉ピザや、自然派ワイン、オーガニック食材を生産者から直接に仕入れた食材を用いたタパスなどが愉しめるピッツェリアです！
ピザを食べたいけど、せっかくなら体に優しいものが食べたいという方でも、デリバリーで注文ができます。`}</p>
    <h3>{`カラブレーゼ(1,880 円)`}</h3>
    <InstaImage postId="B0lOr9-Diiy" mdxType="InstaImage" />
    <p>{`トマトソースをベースに、赤玉ねぎ、青唐辛子、揚げナスを使ったボリューム満点のピザ！ピリッとした風味に、トマトの酸味やナスの甘味が広がる一品。
デリバリーでも人気のメニューになっているので、普段とは違った味が楽しみたい方は、こちらのメニューをご注文ください！`}</p>
    <h3>{`マリナーラ( 1,080 円)`}</h3>
    <InstaImage postId="B2Wf4omjCpy" mdxType="InstaImage" />
    <p>{`先ほどの二店舗と同様に、シンプルで一番その店の味が試されるマリナーラ。
均等にトッピングされたトマトソースと、ガーリック、バジルが織りなす風味に、記事の食感が楽しめる一品！`}</p>
    <h3>{`篠島(シノジマ)(1,980 円)`}</h3>
    <InstaImage postId="BzDC3o8HvgQ" mdxType="InstaImage" />
    <p>{`たっぷりとトッピングされたシラス、大葉、青唐辛子 、ニンニク 、モッツァレラがトッピングされた一品になっています。
名前が漢字という目を引く一品になっていますが、チーズベースのピザで大葉の香りと新鮮なシラスの食感を楽しめる一品になっています。`}</p>
    <h3>{`支払い`}</h3>
    <p>{`クレジットカードが使用できます！普段現金を持たない人でも安心して決済ができるのは嬉しいですよね。`}</p>
    <hr></hr>
    <h2>{`各店舗の詳しい詳細`}</h2>
    <p>{`各店舗で他のメニューも見てみたい方は、下記のサイトにアクセスすると確認することができます！`}</p>
    <h3>
  <a href="https://www.ubereats.com/jp/tokyo/food-delivery/%E3%83%88%E3%83%A9%E3%83%83%E3%83%88%E3%83%AA%E3%82%A2-%E3%83%92%E3%83%83%E3%83%84%E3%82%A7%E3%83%AA%E3%82%A2-%E3%83%8A%E3%83%95%E3%83%AC-%E5%8D%97%E9%9D%92%E5%B1%B1-trattoria-pizzeria-napule-minami-aoyama/wEpXVSMRQJihSFB7QBVvXw">
    ナプレ 南青山本店
  </a>
    </h3>
    <h3>
  <a href="https://kevelos.favy.jp/menus/279450">
    ピッツァ ケベロス 明治神宮前店
  </a>
    </h3>
    <h3>
  <a href="https://tabelog.com/tokyo/A1306/A130601/13180224/dtlmenu/lunch/">
    ピッツェリア カンテラ
  </a>
    </h3>
    <hr></hr>
    <h3>{`おわりに　`}</h3>
    <p>{`原宿の名店のピザデリバリーについてご紹介してきましたが、いかがでしたでしょうか。お店に行くよりは家でゆっくり食べたかったり、たまには本格的なピザが食べたいという方は、デリバリーができる原宿のピザで、素敵な時間をお過ごしください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;